import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import {Loading} from '../../SVG'

import CardBase from '../../cards/CardBase'
import {HibModal} from '../../HibModal'

import { MoneyFormate } from '../../MoneyFormate'
import WebServiceContext from "../../../webService/WebServiceContext";
import { BasicContext } from "../../../context/BasicContext";

type ProductsRankProps = {
    //SPString?:string //要執行的SP
    //mdata: Manager.ManagerData[]
}


const Content = (
    props: {
        cardName: string
        pdata: Manager.ProductProps[]
    }
) => {

    const [year, setYear] = useState<string>("")
    const [insName, setInsName] = useState<string>("")
    //const [open, setOpen] = useState<boolean>(false)
    const [rankList, setRankList] = useState<MixChart.DepDataProps[]>([])

    return (
        <>
        <CardBase
            collapseDisabled={true}
            collapseControl={true}
            title={props.cardName}
            type="productsRanking"
            children={
                props.pdata.map((product: Manager.ProductProps, index: number) => {
                    console.log(product)
                    //const row: MixChart.DepDataProps[] = JSON.parse(product.DepData) as MixChart.DepDataProps[]
                    return (
                        <button
                            onClick={()=>{
                                setYear(props.cardName)
                                setInsName(product.InsName)
                                setRankList( JSON.parse(product.DepData) as MixChart.DepDataProps[])
                            }}
                          
                            className="hibBtn full"
                            key={"product" + index}
                        >
                            <span>
                                No. {index + 1}
                            </span>
                            <span>
                                {product.InsName}
                            </span>
                            <span >
                                {product.OverPrd}
                            </span>
                           

                        </button>
                    )
                })

            }
        />
        <HibModal
            title={"區處業績排名"}
            show={rankList.length>0 ? true:false}
            className="productsRanking"
            type="sm"
            cancel={() => { setRankList([]) }}
            children={        
                <>
                    <h5>{year}</h5>
                    <h5>{insName}</h5>
                    <table className="hibTable" >
                        <thead>
                            <tr>
                                <th>排名</th>
                                <th>區處</th>
                                <th style={{textAlign:"center"}}>業績</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                rankList.map((depData: MixChart.DepDataProps, index: number) =>
                                    <tr>
                                        <td>No.{index+1}</td>
                                        <td>{depData.區處}</td>
                                        <td style={{textAlign:"right"}}>{MoneyFormate(depData.業績)}</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </>    
            }
        />
    </>
    )
}

export default (props: ProductsRankProps) => {
    const bs = useContext(BasicContext)
    const ws = useContext(WebServiceContext)
    
    const [mdata, setMdata] = useState< Manager.ManagerData[]>([])


    useEffect(() => {
        //console.log(bs.SPType, bs.SPGroupID)
        if( bs.SPType !="" && bs.SPGroupID !=""){
            console.log("in")
            ws.webservice.asyncManagerReader(bs.SPType, bs.SPGroupID, "%").then((res:any) => {
                const cdps: Manager.ManagerData[] = res as Manager.ManagerData[]
                //console.log(cdps)
                //setOpen(false)
                setMdata(cdps)
            })
        }
    }, [bs.SPType, bs.SPGroupID])

    return (
        <>  
            {
            
                mdata.length > 0 ?
                    mdata.map((mdp: Manager.ManagerData, index: number) => {
                        //console.log(mdp)
                        const thisYearProduct: Manager.ProductProps[] = mdp.ThisYear?JSON.parse(mdp.ThisYear) as Manager.ProductProps[]:[];
                        const lastYearProduct: Manager.ProductProps[] = mdp.LastYear?JSON.parse(mdp.LastYear) as Manager.ProductProps[]:[];
                        return (
                            <>
                                {
                                    thisYearProduct && thisYearProduct.length > 0 &&
                                    <Content key={"mCard_" + index} cardName="今年度" pdata={thisYearProduct} />

                                }
                                {
                                    lastYearProduct && lastYearProduct.length > 0 &&
                                    <Content key={"mCard_" + index} cardName="去年度" pdata={lastYearProduct} />

                                }
                            </>
                        )
                    })
                :
                <Loading/>
            }
        </>)
}